// Utility function to get service tag colors
export const getServiceTagColor = (serviceName) => {
    const serviceColors = {
        'Investment Management': { bg: '#1e40af', text: '#ffffff' }, // Blue
        'Finances': { bg: '#059669', text: '#ffffff' }, // Green
        'Home Renovation': { bg: '#dc2626', text: '#ffffff' }, // Red
        'Dessert/Drinks': { bg: '#ea580c', text: '#ffffff' }, // Orange
        'Legal': { bg: '#7c3aed', text: '#ffffff' }, // Purple
        'Moving': { bg: '#0891b2', text: '#ffffff' }, // Cyan
        'Repairs': { bg: '#059669', text: '#ffffff' }, // Green
        'Activities': { bg: '#db2777', text: '#ffffff' }, // Pink
        'Outdoor Services': { bg: '#16a34a', text: '#ffffff' }, // Green
        'Tax Prep': { bg: '#ca8a04', text: '#ffffff' }, // Yellow
        'Cleaning': { bg: '#0891b2', text: '#ffffff' }, // Cyan
        'Movies & TV': { bg: '#dc2626', text: '#ffffff' }, // Red
        'Investment Tips': { bg: '#1e40af', text: '#ffffff' }, // Blue
        'Books': { bg: '#7c3aed', text: '#ffffff' }, // Purple
        'Restaurants': { bg: '#ea580c', text: '#ffffff' }, // Orange
        'Real Estate': { bg: '#059669', text: '#ffffff' }, // Green
        'Auto Services': { bg: '#0891b2', text: '#ffffff' }, // Cyan
        'Miscellaneous': { bg: '#6b7280', text: '#ffffff' }, // Gray
        'Utilities': { bg: '#ca8a04', text: '#ffffff' }, // Yellow
        'Food/Groceries': { bg: '#16a34a', text: '#ffffff' }, // Green
    };
    
    // Debug: Log service names that don't match
    if (!serviceColors[serviceName]) {
        console.log('Service name not found in color mapping:', serviceName);
    }
    
    return serviceColors[serviceName] || { bg: '#6b7280', text: '#ffffff' }; // Default gray
}; 